/* Pojedynczy wpis bloga: spis tresci i pozycja paska z odnosnikiem.

   Oba biora sie z naglowkow w tresci wpisu, ktora przychodzi z panelu jako
   gotowy HTML - Liquid nie umie dopisac im identyfikatorow ani niczego miedzy
   nie wstawic, wiec robi to przegladarka.

   Bez skryptu strona jest kompletna: spis zostaje ukryty (atrybut hidden),
   a pasek stoi na koncu tresci. */
(() => {
  const SPIS_MINIMUM = 2;

  // Identyfikator z tytulu naglowka: polskie znaki na laciskie, reszta na
  // lacznik. Gdy z tytulu nic nie zostanie, wchodzi numer porzadkowy.
  const uchwyt = (tekst, numer) => {
    const bez_ogonkow = tekst
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ł/g, 'l');

    const rdzen = bez_ogonkow.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

    return rdzen ? `wpis-${rdzen}` : `wpis-naglowek-${numer}`;
  };

  // Projekt numeruje pozycje spisu, a naglowki w tresci z panelu numerow
  // zwykle nie maja - wiec numer dokleja spis. Gdy autor napisal go sam
  // ("1. Sprawdz podloze"), drugiego nie dokladamy.
  const MA_NUMER = /^\d+\s*[.)]\s+/;

  const zNumerem = (tytul, numer) => (MA_NUMER.test(tytul) ? tytul : `${numer}. ${tytul}`);

  const zlozSpis = (tresc, naglowki) => {
    const spis = document.querySelector('[data-article-toc]');
    const lista = spis && spis.querySelector('[data-article-toc-list]');
    if (!spis || !lista) return;

    if (naglowki.length < SPIS_MINIMUM) return;

    const uzyte = new Set();

    naglowki.forEach((naglowek, i) => {
      if (!naglowek.id) {
        let id = uchwyt(naglowek.textContent.trim(), i + 1);
        while (uzyte.has(id) || document.getElementById(id)) id = `${id}-${i + 1}`;
        naglowek.id = id;
      }
      uzyte.add(naglowek.id);

      const pozycja = document.createElement('li');
      const odnosnik = document.createElement('a');
      odnosnik.className = 'article-toc__link';
      odnosnik.href = `#${naglowek.id}`;
      odnosnik.textContent = zNumerem(naglowek.textContent.trim(), i + 1);
      pozycja.appendChild(odnosnik);
      lista.appendChild(pozycja);
    });

    spis.hidden = false;
    tresc.dataset.tocReady = 'true';
  };

  // Pasek ma stanac POD sekcja o zadanym numerze, czyli tuz przed kolejnym
  // naglowkiem. Gdy wpis ma mniej naglowkow, zostaje tam, gdzie jest.
  const ustawPasek = (naglowki) => {
    const pasek = document.querySelector('[data-article-cta]');
    if (!pasek) return;

    const numer = parseInt(pasek.dataset.poNaglowku, 10);
    if (!numer || numer < 1) return;

    const nastepny = naglowki[numer];
    if (!nastepny) return;

    nastepny.parentNode.insertBefore(pasek, nastepny);
  };

  const init = () => {
    const tresc = document.querySelector('[data-article-content]');
    if (!tresc || tresc.dataset.ready === 'true') return;

    tresc.dataset.ready = 'true';

    const naglowki = Array.from(tresc.querySelectorAll('h2'));

    zlozSpis(tresc, naglowki);
    ustawPasek(naglowki);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Edytor motywu podmienia HTML sekcji bez odswiezenia strony.
  document.addEventListener('shopify:section:load', init);
})();
